import React from "react";
import arrowIcon from "../../images/menuListIcons/arrow-icon.svg";
import arrowUpIcon from "../../images/menuListIcons/arrow-up-icon.svg";
import { useState } from "react";
import { useSelector } from "react-redux";

const RecursiveStructureItem = ({ itemData, index, isItFirst = false, nextIndex, isAllOpen = false }) => {
    const [showSecondItems, setShowSecondItems] = useState(isAllOpen);

    const frameId = useSelector((store) => store.status.iFrameId);
    const isShowIframes = useSelector((store) => store.status.isShowIframes);

    const scrollToElementHandler = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    };

    const isItLastClass = itemData.children.length === 0 && "structure-list__column-item-third";
    const isItFirstClass = isItFirst && "structure-list__column-item-title";
    const lastElementNumber = itemData.children.length === 0 && nextIndex + 1;
    const middleElementNumber = itemData.children.length > 0 && index + 1;
    const firstElementNumber = !isItFirst && itemData.children.length > 0 && nextIndex + 1;
    const isItLastElement = itemData.children.length > 0;
    const isItElementWithChildren = itemData.children.length > 0;
    return (
        <div className="structure-list__column-item">
            <div
                className={isItFirstClass || isItLastClass || "structure-list__column-item-second"}
                onClick={() => setShowSecondItems(!showSecondItems)}
            >
                {lastElementNumber}
                {middleElementNumber}.{firstElementNumber}
                {itemData.title}
                {isItLastElement && (
                    <img
                        src={showSecondItems ? arrowUpIcon : arrowIcon}
                        alt=""
                        className="structure-list__column-item-title-arrow"
                    />
                )}
            </div>
            {isShowIframes &&
                itemData?.file?.iframes.map((frame, index) => {
                    return (
                        <div
                            className={
                                frameId === `${itemData?.file.id}-${index}`
                                    ? "structure-list__column-item-frame active"
                                    : "structure-list__column-item-frame "
                            }
                            key={index}
                            onClick={() => scrollToElementHandler(`${itemData?.file.id}-${index}`)}
                        >
                            {frame.title}
                        </div>
                    );
                })}
            {showSecondItems &&
                isItElementWithChildren &&
                itemData.children.map((nextItem, nextIndex) => {
                    return (
                        <RecursiveStructureItem
                            itemData={nextItem}
                            index={index}
                            nextIndex={nextIndex}
                            key={nextItem.id + nextItem.title}
                            isAllOpen={isAllOpen}
                        />
                    );
                })}
        </div>
    );
};

export default RecursiveStructureItem;
